<template>
    <Modal
        class="wrap"
        v-model="modal"
        :title="type === 'add' ? $t(local_install?'pages.employee.add':'pages.employee.inviteUser') : $t('pages.employee.setUser')"
        :mask-closable="false"
        width="520">
        <Form class="formValidate" ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
            <FormItem v-if="type === 'edit'" :label="$t('pages.employee.userName')" prop="name">
                <p>{{ formValidate.name }}</p>
            </FormItem>
            <FormItem v-if="type === 'edit'" :label="$t('pages.employee.noteName')" prop="alias">
                <Input v-model="formValidate.alias"></Input>
            </FormItem>
            <FormItem :label="$t('navigation.structure')" prop="department_id">
                <Select ref="department" v-model="formValidate.department_id" style="width:200px" transfer>
                    <Option style="display: none;" :value="departmentInfo.department_id">{{ departmentInfo.title }}</Option>
                    <Tree :data="data" @on-select-change="handleTree($event, 'department')" ></Tree>
                </Select>
            </FormItem>
            <FormItem :label="$t('pages.employee.userRole')" prop="roles">
                <CheckboxGroup v-model="formValidate.roles">
                    <Checkbox v-for="item in roleList" :key="item.rowid" :label="item.rowid">{{ item.name }}</Checkbox>
                </CheckboxGroup>
            </FormItem>
            <template v-if="type === 'add' && local_install">
                <FormItem :label="$t('pages.employee.userName')" prop="name">
                    <Input v-model="formValidate.name" :placeholder="$t('pages.employee.inputName')"></Input>
                </FormItem>
                <FormItem :label="$t('pages.employee.account')" prop="account">
                    <Input v-model="formValidate.account" :placeholder="$t('pages.login.inputAccount')"></Input>
                </FormItem>
                <FormItem :label="$t('pages.employee.password')" prop="password">
                    <Input v-model="formValidate.password" type="password" password :placeholder="$t('pages.employee.inputPwd')"></Input>
                </FormItem>
                <FormItem :label="$t('pages.employee.password2')" prop="password2">
                    <Input v-model="formValidate.password2" type="password" password :placeholder="$t('pages.employee.inputPwdAgain')"></Input>
                </FormItem>
            </template>
        </Form>
        <div slot="footer" style="margin-right: 15%;">
            <Button type="default" @click="cancel">{{ $t('common.cancel') }}</Button>
            <Button type="primary" :loading="loading" @click="submit"><span v-if="type==='edit'">{{ $t('common.confirm') }}</span><span v-else>{{ $t(local_install?'common.confirm':'pages.employee.generateLink') }}</span></Button>
        </div>
        <invite-modal
            :show="inviteModalShow"
            :text="text"
            @cancel="handleInviteModalCancel"
        ></invite-modal>
    </Modal>  
</template>
<script>
    import sha1 from 'sha1'
    import inviteModal from './inviteModal'

    export default {
        name: "",
        mixins: [],
        components: {
            inviteModal
        },
        props: {
            show: {
                default: false
            },
            type: {
                default: 'add'
            },
            user_id: {
                default: null
            },
            local_install: {
                default: false
            }
        },
        data () {
            return {
                modal: false,
                loading: false,
                formValidate: {
                    alias: '',
                    mobile: '',
                    roles: [],
                    name: '',
                    department_id: null,
                    account: '',
                    password: '',
                    password2: ''
                },
                departmentInfo: {
                    department_id: '',
                    title: ''
                },
                nodeData: {},
                data: [],
                roleList: [],
                inviteModalShow: false,
                text: ''
            }
        },
        computed: {
            tree_data() {
                return [this.$store.state.department_tree]
            },
            ruleValidate() {
                return {
                    // mobile: [
                    //     { required: true, type: 'string', validator: (rule, value, callback) => {
                    //         var regex = /^1[3456789]\d{9}$/
                    //         if (!regex.test(value)) {
                    //             callback(new Error('请输入手机号码'))
                    //         } else {
                    //             callback()
                    //         }
                    //     }, trigger: 'blur' }
                    // ],
                    roles: [
                        { required: true, type: 'array', min: 1, message: this.$t('common.select'), trigger: 'change' }
                    ],
                    department_id: [
                        {
                            required: true, type: 'number', message: this.$t('common.input'), trigger: 'blur'
                        }
                    ],
                    account: [
                        { required: true, type: 'string', validator: ( rule,value, callback) => {
                            let regex = /^[0-9a-zA-Z_]{4,32}$/
                            if (!regex.test(value)) {
                                callback(new Error(this.$t('pages.login.inputAccount2')))
                            } else {
                                callback()
                            }
                        }, trigger: 'blur' }
                    ],
                    password: [
                        { required: true, type: 'string', min: 6, max: 30,  message: this.$t('pages.login.inputPassword'), trigger: 'blur' }
                    ],
                    password2: [
                        { required: true, type: 'string', min: 6, max: 30,  message: this.$t('pages.login.inputPassword'), trigger: 'blur' }
                    ],
                    name: [
                        { required: true, type: 'string', min: 1, max: 32, message: this.$t('pages.employee.inputName'), trigger: 'blur' }
                    ]
                }
            }
        },
        watch: {
            async show(val) {
                this.modal = val
                if (val) {
                    this.formValidate.department_id = this.nodeData.department_id || ''
                    if (this.type === 'edit') {
                        await this.$api.get(`organizations/current/users/${this.user_id}`).then(({ data }) => {
                            this.formValidate = {
                                alias: data.alias,
                                name: data.name,
                                department_id: data.department_id,
                                roles: data.role_id_list
                            }
                        })
                    }
                    if (this.type === 'add') {
                        this.formValidate.department_id = this.tree_data[0].department_id
                    }
                    this.data = this.handleRecursive(this.tree_data, this.formValidate.department_id)
                    this.departmentInfo = {
                        department_id: this.nodeData.department_id || '',
                        title: this.nodeData.title || ''
                    }
                    let params = {
                        include_super_role: false
                    }
                    this.$api.get('organizations/current/roles/search', { params }).then(({ data }) => {
                        this.roleList = data
                    })
                }
            },
            modal(val) {
                if (!val) {
                    this.cancel()
                }
            }
        },
        methods: {
            cancel() {
                this.formValidate = {
                    alias: '',
                    mobile: '',
                    roles: [],
                    name: '',
                    department_id: null,
                    account: '',
                    password: '',
                    password2: ''
                }
                this.departmentInfo =  {
                    department_id: '',
                    title: ''
                }
                this.nodeData = {}
                this.$emit('cancel')
                this.$refs['formValidate'].resetFields();
            },
            submit() {
                this.$refs['formValidate'].validate((valid) => {
                    if (valid) {
                        this.loading = true
                        if (this.type === 'add') {
                            let params = {
                                department_id: this.formValidate.department_id,
                                role_list: JSON.stringify(this.formValidate.roles)

                            }
                            if (this.local_install) {
                                if (this.formValidate.password !== this.formValidate.password2) {
                                    this.loading = false
                                    return this.$Message.error(this.$t('pages.employee.pwdErr'))
                                }
                                params.name = this.formValidate.name
                                params.account = this.formValidate.account
                                params.password = sha1(this.formValidate.password)
                                this.$api.post('organizations/current/users/new_user', params).then(() => {
                                    this.$emit('confirm')
                                    this.cancel()
                                    this.$Message.success(this.$t('message.success'))
                                }).catch(() => {}).finally(() => {
                                    this.loading = false
                                })
                                return
                            }
                            this.$api.get('organizations/current/users/invite_user_code', { params }).then(({ url }) => {
                                this.text = `${location.origin}/#/invite_user${url}`
                                this.inviteModalShow = true
                                this.$emit('confirm')
                                this.cancel()
                                this.$Message.success(this.$t('message.success'));
                            }).finally(() => {
                                this.loading = false
                            })
                        } else {
                            let params = {
                                alias: this.formValidate.alias,
                                department_id: this.formValidate.department_id,
                                role_list: this.formValidate.roles
                            }
                            this.$api.put(`organizations/current/users/${this.user_id}`, params).then(() => {
                                this.$emit('confirm')
                                this.cancel()
                                this.$Message.success(this.$t('message.success'));
                            }).finally(() => {
                                this.loading = false
                            })
                        }
                    }
                })
            },
            handleTree(e, name) {
                if (name === 'department') {
                    if (e.length === 0) {
                        this.departmentInfo = {
                            title: '',
                            department_id: ''
                        }
                    } else {
                        this.departmentInfo = {
                            department_id: e[0].department_id,
                            title: e[0].title
                        }
                        this.formValidate.department_id = e[0].department_id
                        this.$refs['department'].hideMenu()
                    }
                }
            },
            handleRecursive(array, key) {
                let arr = []
                for (var i = 0; i < array.length; i++) {
                    let obj = {}

                    //获取相应key节点数据
                    if (key === array[i].department_id) {
                        this.nodeData = {
                            department_id: array[i].department_id,
                            title: array[i].name
                        }
                        obj.selected = true
                    }
                    obj.title = array[i].name
                    obj.expand = true
                    for (let k in array[i]) {
                        if (Object.prototype.hasOwnProperty.call(array[i], k)) {
                            if (array[i][k] === null) continue
                            obj[k] = array[i][k].constructor !== Array ? array[i][k] : this.handleRecursive(array[i][k], key)
                        }
                    }
                    arr.push(obj)
                }
                return arr
            },
            handleInviteModalCancel() {
                this.inviteModalShow = false
            }
        },
        created() {}
    }
</script>
<style scoped lang="less">
.formValidate {
    width: 80%;
}
</style>
